import { Box, FormControl, IconButton, InputLabel, LinearProgress, MenuItem, Modal, Select, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { CustomTabPanel } from 'src/tecnica/pages/dashboard/reports/close_daily';
import Grid from "@mui/material/Grid2";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { IUpdateDiagnosticForActivity, updateFieldVariablesValues, UpdateDiagnosticForActivity } from 'src/shared/util/updateDataServer';
import Swal from 'sweetalert2';
import { loadLocationDetails } from 'src/stateManagement/redux/slices/location/asyncReducers';
import '../cartas_dinagraficas/components/styles.scss'


const status_candidato_listy = [
    { id: "Reevaluación", name: "Reevaluación" },
    { id: "Oportunidad de Incremento", name: "Oportunidad de Incremento" },
    { id: "Mantener Condiciones", name: "Mantener Condiciones" }
]

const condicion_fondo_list = [
    { id: "Golpe de Fluido", name: "Golpe de Fluido", dissabled: true },
    { id: "Inteferencia por Gas", name: "Inteferencia por Gas",dissabled: true  },
    { id: "Pendiente por Determinar", name: "Pendiente por Determinar" },
    { id: "Buenas Condiciones", name: "Buenas Condiciones" },
    { id: "Golpe de Bomba", name: "Golpe de Bomba", dissabled: true  },
    { id: "Baja Accion de Bombeo", name: "Baja Accion de Bombeo" },
    { id: "Fuga en Valvula Viajera", name: "Fuga en Valvula Viajera", dissabled: true  },
    { id: "Fuga en Valvula Fija", name: "Fuga en Valvula Fija", dissabled: true  },
    { id: "Cierre Tardio de Valvula Fija", name: "Cierre Tardio de Valvula Fija", dissabled: true  },
    { id: "Cierra Tardio de Valvula Viajera", name: "Cierra Tardio de Valvula Viajera", dissabled: true  },
    { id: "Flumping", name: "Flumping", dissabled: true  }
];

const taskStates = [
    { id: "pending", name: "Por Analizar" },
    { id: "analyzing", name: "Evaluar Luego" },
    { id: "finished", name: "Analizada" }
];


export const ModalFixLiquidLevel = ({ open, liquidLevel, onClose }: { open: any, liquidLevel: any, onClose: any }) => {

    const [loading, setloading] = useState(false)

    const [value, setValue] = useState(0);

    const { id } = useParams();

    const dispatch = useDispatch();

    const { projectId, locationId } = useSelector((state) => state.location);

    const { activeUser } = useSelector((state) => state.main);

    const [activeDiagnostic, setActiveDiagnostic] = useState<IUpdateDiagnosticForActivity>()

    const [variablesToUpdate, setVariablesToUpdate] = useState<any>(undefined)

    useEffect(() => {

        const originFieldActivityIds: string[] = [liquidLevel?.fieldActivityId]

        // liquid Level

        const newVariablesToUpdate = {
            originFieldActivityIds,
            // pip: liquidLevel?.pip || 0,
            // pwf: liquidLevel?.pwf || 0,
            // pumpSumergence: liquidLevel?.pumpSumergence || 0,
            // liquidLevel: liquidLevel?.liquidLevel || 0
        }

        setVariablesToUpdate(newVariablesToUpdate)

        const previousDiagnostic = liquidLevel['diagnosticVariables']

        const diagnostic = previousDiagnostic?.find((v: any) => v.id === "26fd1c80-ec8d-11ef-95e3-00505652cca1")?.value || ""

        const recommendations = previousDiagnostic?.find((v: any) => v.id === "26fd1ece-ec8d-11ef-95e3-00505652cca1")?.value || ""

        const candidateSate = previousDiagnostic?.find((v: any) => v.id === "26fd1f13-ec8d-11ef-95e3-00505652cca1")?.value || ""

        const bottomHoleConditions = previousDiagnostic?.find((v: any) => v.id === "26fd1f4d-ec8d-11ef-95e3-00505652cca1")?.value || ""

        const subBottomHoleConditions = previousDiagnostic?.find((v: any) => v.id === "3e545921-fc61-11ef-a39b-00505652cca1")?.value || ""

        const bottomHoleFillage = previousDiagnostic?.find((v: any) => v.id === "26fd1f8a-ec8d-11ef-95e3-00505652cca1")?.value

        const ept = previousDiagnostic?.find((v: any) => v.id === "bca80cfd-fcdd-11ef-a39b-00505652cca1")?.value

        const theoricalProduction = previousDiagnostic?.find((v: any) => v.id === "3e545b5c-fc61-11ef-a39b-00505652cca1")?.value

        const pumpEfficiency = previousDiagnostic?.find((v: any) => v.id === "81047dd8-05d4-11f0-af91-00505652cca1")?.value

        const adjustProduction = previousDiagnostic?.find((v: any) => v.id === "1a6387e8-05db-11f0-af91-00505652cca1")?.value

        const dplunger = previousDiagnostic?.find((v: any) => v.id === "e47fc3c4-fc6f-11ef-a39b-00505652cca1")?.value

        const newActiveDiagnostic: IUpdateDiagnosticForActivity = {
            originFieldActivityIds,
            projectId: projectId,
            locationId: locationId,
            diagnostic: diagnostic || '',
            recommendation: recommendations || '',
            candidateSate: candidateSate || '',
            bottomHoleCondition: bottomHoleConditions || '',
            subBottomHoleCondition: subBottomHoleConditions || '',
            bottomHoleFillage,
            requiredUserId: activeUser?.id || '',
            executedAt: new Date(),
            ept,
            theoricalProduction,
            pumpEfficiency,
            adjustProduction,
            mpt: 0,
            dplunger,
            newFieldActivityState: 'finished',
            optimizationActivitiesSelected: [],
            includeAttachments: false,
            attachedFiles: [],
            runLife: 0,
            lastSubSurfaceJobFinishedDate: '',
            daysAfterSteamInjection: 0,
            lastLocationEventHistoryChangeDate: '',
            cicleCount: 0,
        }

        setActiveDiagnostic(newActiveDiagnostic)
    }, [liquidLevel])

    const validateDiagnostic = () => {
        const fieldsToValidate = [
            { field: 'diagnostic', message: "El campo diagnostico es requerido" },
            { field: 'recommendation', message: "El campo recomendacion es requerido" },
            { field: 'candidateSate', message: "El campo estado candidato es requerido" },
            { field: 'bottomHoleCondition', message: "El campo condicion de fondo es requerido" }]

        const messageErros: string[] = []

        if (!activeDiagnostic) return messageErros

        const diagnosticTovalidate: any = { ...activeDiagnostic }

        fieldsToValidate.forEach((f) => {
            if (!diagnosticTovalidate[f.field] || diagnosticTovalidate[f.field].trim() === "") {
                messageErros.push(f.message)
            }
        }
        )
        return messageErros
    }

    const onSaveDiagnostic = () => {

        if (variablesToUpdate && value === 0) {
            setloading(true)
            updateFieldVariablesValues(variablesToUpdate).then((data) => {
                setloading(false)
                Swal.fire({
                    title: "Guardado!",
                    icon: "success",
                });
                dispatch(loadLocationDetails(id!));
            }
            ).catch((error) => {
                Swal.fire({
                    title: "Error!",
                    icon: "error",
                });
                console.log(error)
                setloading(false)
            })
        }


        if (activeDiagnostic && value === 1) {

            const errors = validateDiagnostic()

            if (errors.length > 0) {
                Swal.fire({
                    title: "Error!",
                    icon: "error",
                    html: `<p>No se puede proceder debido a los siguientes errores:</p><ul>${errors.map(error => `<li>${error}</li>`).join('')}</ul>`

                });
                return
            }

            setloading(true)
            UpdateDiagnosticForActivity(activeDiagnostic).then((data) => {
                setloading(false)
                Swal.fire({
                    title: "Guardado!",
                    icon: "success",
                });
                dispatch(loadLocationDetails(id!));
            }
            ).catch((error) => {
                Swal.fire({
                    title: "Error!",
                    icon: "error",
                });
                console.log(error)
                setloading(false)
            })
        }
    }

    const handleClose = () => {
        if (loading) return
        onClose()
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleOnChangeValue = (value: any, label: any) => {
        const newActiveDiagnostic: any = { ...activeDiagnostic }
        newActiveDiagnostic[label] = value

        if (label === "bottomHoleCondition") {

            let subBottomHoleCondition = ""

            const condicionesDeficiente = ['Fuga en Valvula Viajera', 'Fuga en Valvula Fija', 'Cierre Tardio de Valvula Fija', 'Cierra Tardio de Valvula Viajera', 'Flumping', "Baja Accion de Bombeo"]

            switch (value) {
                case "Golpe de Fluido":
                    if ((activeDiagnostic?.bottomHoleFillage || 0) < 20) {
                        subBottomHoleCondition = "Golpe de Fluido Critico (<20%)"
                    } else if ((activeDiagnostic?.bottomHoleFillage || 0) < 50) {
                        subBottomHoleCondition = "Golpe de Fluido Llenado Medio (20% al 50%)"
                    } else {
                        subBottomHoleCondition = "Golpe de Fluido Buen Llenado (50% al 90%)"
                    }

                    break;
                case "Inteferencia por Gas":
                    if ((activeDiagnostic?.bottomHoleFillage || 0) < 20) {
                        subBottomHoleCondition = "Inteferencia por Gas Critico (<20%)"
                    } else if ((activeDiagnostic?.bottomHoleFillage || 0) < 50) {
                        subBottomHoleCondition = "Inteferencia por Gas Llenado Medio (20% al 50%)"
                    } else {
                        subBottomHoleCondition = "Inteferencia por Gas Buen Llenado (50% al 90%)"
                    }

                    break;

                default:
                    if (condicionesDeficiente.includes(value)) {
                        subBottomHoleCondition = "Deficiente";
                    } else {
                        subBottomHoleCondition = value;
                    }
                    break;

            }

            newActiveDiagnostic["subBottomHoleCondition"] = subBottomHoleCondition
        }

        setActiveDiagnostic(newActiveDiagnostic)
    }

    const onChangeLiquidLevel = (value: any, label: any) => {
        const newVariablesToUpdate: any = { ...variablesToUpdate }
        newVariablesToUpdate[label] = value
        setVariablesToUpdate(newVariablesToUpdate)
    }

    // ===============================

    return (
        <Modal
            open={open}
            onClose={() => onClose()}
        >
            <Box className="modal_update_card_location">
                {/* headers */}
                <Box className="modal_header">
                    <IconButton
                        aria-label="delete"
                        size='small'
                        onClick={handleClose}
                    >
                        <CloseIcon color="error" />
                    </IconButton>
                    <Typography className='title' id="modal-modal-title" variant="h6" component="h2">
                        Analizar Nivel
                    </Typography>
                    <IconButton
                        aria-label="delete"
                        size='small'
                        onClick={() => onSaveDiagnostic()}
                    >
                        <SaveOutlinedIcon color="primary" />
                    </IconButton>
                </Box>
                {loading && (
                    <>
                        <Box className="modal_analyst_loading_background" />
                        <Box className="modal__analyst_task_loading">
                            <LinearProgress />
                            Saving....
                        </Box>
                    </>
                )}
                {/* Body */}
                <Box sx={{ p: 2, gap: 2 }} >
                    {/* Tabs */}
                    <Box
                        sx={{
                            borderBottom: 1,
                            borderColor: "divider",
                        }}
                    >
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            scrollButtons="auto"
                            variant="scrollable"
                        >
                            <Tab
                                label="Actualizar Nivel"
                            />
                            <Tab
                                label="Agregar Diagnóstico"
                            />
                        </Tabs>
                    </Box>
                    {/* actualizar nivel */}
                    <CustomTabPanel value={value} index={0}>
                        <Grid container spacing={2} style={{ display: 'flex', flexWrap: 'wrap', padding: '10px' }}>
                            <Grid size={6}>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Nivel (ft)"
                                    onChange={(e) => {
                                        const value = parseFloat(e.target.value.replace(/[^0-9.]/g, '')) || 0;
                                        if (value > 0) {
                                            onChangeLiquidLevel(value, "liquidLevel");
                                        }
                                    }}
                                    value={variablesToUpdate?.liquidLevel || liquidLevel?.liquidLevel || 0}
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="PIP (psi)"
                                    onChange={(e) => {
                                        const value = parseFloat(e.target.value.replace(/[^0-9.]/g, '')) || 0;
                                        if (value > 0) {
                                            onChangeLiquidLevel(value, "pip");
                                        }
                                    }}
                                    value={variablesToUpdate?.pip || liquidLevel?.pip || 0}
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="PWF (psi)"
                                    onChange={(e) => {
                                        const value = parseFloat(e.target.value.replace(/[^0-9.]/g, '')) || 0;
                                        if (value > 0) {
                                            onChangeLiquidLevel(value, "pwf");
                                        }
                                    }}
                                    value={variablesToUpdate?.pwf || liquidLevel?.pwf || 0}
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Sumergencia (ft)"
                                    onChange={(e) => {
                                        const value = parseFloat(e.target.value.replace(/[^0-9.]/g, '')) || 0;
                                        if (value > 0) {
                                            onChangeLiquidLevel(value, "pumpSumergence");
                                        }
                                    }}
                                    value={variablesToUpdate?.pumpSumergence || liquidLevel?.pumpSumergence || 0}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </CustomTabPanel>
                    {/* Actualizar Diagnostico */}
                    <CustomTabPanel value={value} index={1}>
                        < Box className="modal_analyst_body" >
                            <Grid size={12}>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label={"Diagnóstico"}
                                    value={activeDiagnostic?.diagnostic || ""}
                                    onChange={(e) => handleOnChangeValue(e.target.value, "diagnostic")}
                                    fullWidth
                                    error={!activeDiagnostic?.diagnostic || activeDiagnostic?.diagnostic.trim() === ""}
                                    multiline
                                    rows={5}
                                />
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label={"Recomendación"}
                                    onChange={(e) => handleOnChangeValue(e.target.value, "recommendation")}
                                    value={activeDiagnostic?.recommendation || ""}
                                    error={!activeDiagnostic?.recommendation || activeDiagnostic?.recommendation.trim() === ""}
                                    fullWidth
                                    multiline
                                    rows={5}
                                />
                            </Grid>
                            <Grid className="list_section">
                                <FormControl>
                                    <InputLabel>Estatus Candidato</InputLabel>
                                    <Select
                                        value={activeDiagnostic?.candidateSate || ""}
                                        label="Estatus Candidato"
                                        onChange={(e) => handleOnChangeValue(e.target.value, "candidateSate")}
                                        error={!activeDiagnostic?.candidateSate || activeDiagnostic?.candidateSate.trim() === ""}
                                    >
                                        {status_candidato_listy.map((status) => (
                                            <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl>
                                    <InputLabel>Condición de Fondo</InputLabel>
                                    <Select
                                        value={activeDiagnostic?.bottomHoleCondition || ""}
                                        label="Condición de Fondo"
                                        onChange={(e) => handleOnChangeValue(e.target.value, "bottomHoleCondition")}
                                        error={!activeDiagnostic?.bottomHoleCondition || activeDiagnostic?.bottomHoleCondition.trim() === ""}
                                    >
                                        {condicion_fondo_list.map((cond) => (
                                            <MenuItem key={cond.id} value={cond.id} disabled={cond.dissabled}>
                                                {cond.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl>
                                    <InputLabel>Nuevo Estado tarea</InputLabel>
                                    <Select
                                        value={activeDiagnostic?.newFieldActivityState || ""}
                                        label="Nuevo Estado tarea"
                                        onChange={(e) => handleOnChangeValue(e.target.value, "newFieldActivityState")}
                                        error={!activeDiagnostic?.newFieldActivityState || activeDiagnostic?.newFieldActivityState.trim() === ""}
                                    >
                                        {taskStates.map((task) => (
                                            <MenuItem key={task.id} value={task.id}>{task.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <Grid className="sub_states_sections">
                                    {/* <Grid className="label">Llenado : </Grid>
                                    <Grid>  {activeDiagnostic?.bottomHoleFillage ? Math.round(activeDiagnostic?.bottomHoleFillage) : 0} % </Grid> */}
                                    <Grid className="label">Sub Condición : </Grid>
                                    <Grid> {activeDiagnostic?.subBottomHoleCondition || ""}  </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </CustomTabPanel>
                </Box>
            </Box>
        </Modal>
    )
}
